/**
 * Logout route.
 *
 * @namespace routes.Logout
 * @type {TmrRoute}
 */
export const route = {
  name: 'logout',
  label: 'Logout',
  component: 'tmrLogout',
  url: '/logout',
  accessControl: [],
}

/**
 * Logout component
 *
 * Executes {@link TmrApiAuth#logout} when initialized.
 *
 * @type {ngComponent}
 */
export const tmrLogout = {
  ngType: 'component',
  controller: 'tmrLogoutController',
}

/**
 * Controller of component {@link tmrLogout}
 *
 * @type {ngController}
 */
export class tmrLogoutController {
  static ngType = 'controller'

  constructor(TmrApiAuth) {
    'ngInject'
    Object.assign(this, { TmrApiAuth })
  }

  $onInit() {
    this.TmrApiAuth.logout()
  }
}
